// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"329":"83c40a78","568":"b2efe2a4","670":"891b6340","977":"0af59dc6"}[chunkId] + ".chunk.js";
};